module.exports = __webpack_public_path__ + "static/media/partner_banner.8474da8d.png";